import { render } from "./PhoneEditableField.vue?vue&type=template&id=7c8a4103&scoped=true"
import script from "./PhoneEditableField.vue?vue&type=script&lang=js"
export * from "./PhoneEditableField.vue?vue&type=script&lang=js"

import "./PhoneEditableField.vue?vue&type=style&index=0&id=7c8a4103&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a4103"]])

export default __exports__